<div class="h-full flex flex-col bg-[#ebebeb] border border-[#757677]">
  @if(tabsNames().length>0) {
  <div class="sticky bg-base-300 top-0 z-7">
    <div class="flex items-center overflow-auto tabs-container scroll-horizontal" #tabsContainer>
      @for (tab of tabsNames(); track tab.path) {
      <div class="tab-item flex text-sm font-medium min-w-fit" [class.active-tab]="visibleNode().path === tab.path"
        [class.inactive-tab]="visibleNode().path !== tab.path">
        <div class="tab-content px-3 py-1.5 flex items-center gap-2" (click)="onclick(tab)">
          <span class="truncate max-w-40">{{ tab.path.split("/").pop() }}</span>
          <button class="close-button flex items-center justify-center"
            (click)="closeTab(tab); $event.stopPropagation()">
            <ng-icon class="text-xs" name="heroXMark"></ng-icon>
          </button>
        </div>
      </div>
      }
    </div>
  </div>
  }
  @if(tabsNames().length>0) {
  <ng-container [ngSwitch]="fileType">
    <ng-container *ngSwitchCase="'code'">
      <editor></editor>
    </ng-container>
    <ng-container *ngSwitchCase="'md'">
      @if(viewMode === 'raw') {
      <editor></editor>
      }@else {
      <div class="h-full overflow-auto mx-5!">
        <markdown ngPreserveWhitespaces [data]="visibleNodeMDContent() | async" class="markdown-content prose h-full">
        </markdown>
      </div>
      }
      <button
        class="fixed right-6 bottom-5 bg-blue-500 backdrop-opacity-55 z-20! px-5 rounded-3xl text-white cursor-pointer"
        (click)="togglePreview()">
        {{ viewMode }}
      </button>
    </ng-container>
    <ng-container *ngSwitchCase="'data'">
      <app-dataviewer></app-dataviewer>
    </ng-container>
    <ng-container *ngSwitchCase="'image'">
      <app-imageviewer></app-imageviewer>
    </ng-container>
    <ng-container *ngSwitchCase="'yaml'">
      <editor fileType="yaml"></editor>
    </ng-container>
    <ng-container *ngSwitchCase="'json'">
      <editor fileType="json"></editor>
      <button class="fixed right-6 top-15 bg-white/10 backdrop-blur-md border border-white-400/50 z-20! px-5 py-2 rounded-3xl text-white cursor-pointer hover:bg-white/20 hover:border-emerald-400/70 transition-all duration-300"
        (click)="viewer()">
        USDM Json Viewer
      </button>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="flex items-center justify-center h-full">
        <p class="text-lg text-black">Unknown file type</p>
      </div>
    </ng-container>
  </ng-container>
  }@else {
  <div class="flex items-center justify-center h-full">
    <p class="text-lg text-black">No file selected</p>
  </div>
  }
</div>